import React from 'react';
import { string, func, oneOf } from 'prop-types';
import classnames from 'classnames/bind';

import { withMediaQuery } from 'common/utils';
import ActionIcon from 'elements/ActionIcons/ActionIcon';
import LinkFreeStanding from 'elements/Link/LinkFreeStanding/LinkFreeStanding';

import styles from './TypeD.css';

const cx = classnames.bind(styles);

const TypeD = ({ className, colorScheme, title, highlighted, description, onClick, link, urlImage }) => {
  const linkArray = [
    {
      minWidth: 1920,
      className: styles.link,
      size: 'm',
      icon: { direction: 'right', name: 'arrow-right', type: '20' },
      onClick: onClick,
      withBouncing: true,
      children: link
    },
    {
      maxWidth: 1919,
      className: styles.link,
      size: 's',
      icon: { direction: 'right', name: 'link-arrow-right-17', type: 'other' },
      onClick: onClick,
      withBouncing: true,
      children: link
    }
  ];

  return (
    <div className={cx('wrapper', colorScheme, className)}>
      <h5 className={styles.title}>
        {highlighted && <span className={styles.highlight}>{highlighted} </span>}
        {title}
      </h5>
      <p className={styles.description}>
        {description}
      </p>
      {withMediaQuery(LinkFreeStanding, linkArray)}
      <ActionIcon
        icon="link-arrow-right"
        type="30"
        customClasses={styles.actionIcon}
        onClick={onClick}
      />
      <div className={styles.image} style={{ backgroundImage: `url('${urlImage}')` }} />
    </div>
  );
};

TypeD.propTypes = {
  className: string,
  colorScheme: oneOf(['lb01', 'lb02']),
  highlighted: string,
  title: string.isRequired,
  description: string.isRequired,
  link: string.isRequired,
  onClick: func.isRequired,
  urlImage: string
};

TypeD.defaultProps = {
  colorScheme: 'lb01'
};

TypeD.displayName = 'TypeD';

export default TypeD;


// WEBPACK FOOTER //
// ./src/uis/components/Banner/HeroBanner/TypeD/TypeD.js